import React from 'react';
import moment from 'moment';
import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination,Row,Col } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import Edit from '../../utils/edit';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
const FormItem = Form.Item;
import greenImg from '../../circleGreen.png';
import redImg from '../../circleRed.png';
import yellowImg from '../../circleYellow.png';

const getDownHostUrl = Urls.MonitorUrl.downHost;


//todo 时间转换函数
export default class extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10
            },
            downloadUrl: getDownHostUrl,
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        this.getList(Urls.MonitorUrl.vps + paramsEncode(this.state.serach));
    }

    async getList(url) {
        try {
            let response = await request(url);
            this.setState(Object.assign(this.state, response));
        } catch (e) {
            alert(e.message)
        }
    }


    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(Urls.MonitorUrl.vps + paramsEncode(this.state.serach));
    }


    render() {
        const columns = [{
            title: '合作商',
            dataIndex: 'partner',
            key: 'partner',
        }, {
            title: '上线时间',
            dataIndex: 'startTime',
            key: 'startTime',
            render: (text, record, index) => {
                return moment(text).format('YYYY-MM-DD hh:mm:ss');
            }
        }, {
            title: '上次更新时间',
            dataIndex: 'lastUpdateTime',
            key: 'lastUpdateTime',
            render: (text, record, index) => {
                return moment(text).format('YYYY-MM-DD HH:mm:ss');
            }
        }, {
            title: '机器IP',
            dataIndex: 'host',
            key: 'host',
        }, {
            title: '端口号',
            dataIndex: 'port',
            key: 'port',
        }, {
            title: '任务状态',
            dataIndex: 'status',
            key: 'status',
            // NORMAL(0),
            // MALFUNCTION(1),
            // WARNING(2);
            render: (text, record, index) => {
                switch (text) {
                    case 0: return <img  src={greenImg} />;
                    case 1: return <img  src={redImg} />;
                    case 2: return <img  src={yellowImg} />;
                }
            }
        }];
        return (
            <div >
                <h2 style={{marginBottom:'20px'}}>VPS监控 </h2>
                <div>
                <Button type="primary" >
                        <a href={this.state.downloadUrl} download="filename">
                                    导出下线机器
                        </a>
                </Button>
                </div>
                <br/>
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className='ant-table-pagination'
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./components/sider/vpsmonitor.js